"use strict";
/**************************
 * ************************
 * ************************
 * COPIED FROM https://github.com/Bond-Sports/NotificationsService
 * ************************
 * ************************
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendResultDto = exports.SendErrorDto = void 0;
class SendErrorDto {
}
exports.SendErrorDto = SendErrorDto;
class SendResultDto {
    constructor(attempted = 0, succeeded = 0, failed = 0, errors) {
        this.attempted = 0;
        this.succeeded = 0;
        this.failed = 0;
        this.errors = [];
        this.attempted = attempted;
        this.succeeded = succeeded;
        this.failed = failed;
        this.errors = errors ? errors : [];
    }
    static withError(error) {
        return new SendResultDto(0, 0, 0, [error]);
    }
    merge(other) {
        this.attempted += other.attempted;
        this.succeeded += other.succeeded;
        this.failed += other.failed;
        this.errors = this.errors.concat(other.errors);
    }
}
exports.SendResultDto = SendResultDto;
//# sourceMappingURL=notification.response.dto.js.map